import type { FactsheetDetails, FactsheetTab } from '@/features/factsheet/types';
import TabPanel from '@/shared/ui/primitives/Tabs/TabPanel';

interface ChartTabContentProps {
  factsheet: FactsheetDetails;
  contentTabs: FactsheetTab[];
  activeTab: number;
}

const ChartTabContent = ({ factsheet, contentTabs, activeTab }: ChartTabContentProps) => (
  <>
    {contentTabs.map((tab, index) => (
      <TabPanel
        key={`${factsheet.code}-chart-${tab.name}`}
        containerSX={{
          flex: 1,
          flexGrow: 1,
          width: '100%',
          overflow: 'hidden',
          ...(index === activeTab ? { display: 'flex' } : {})
        }}
        index={index}
        sx={{
          pt: 2,
          flex: 1,
          flexGrow: 1,
          width: '100%',
          overflow: 'auto'
        }}
        value={activeTab}
      >
        {tab.component}
      </TabPanel>
    ))}
  </>
);

export default ChartTabContent;
